<template>
    <div class="panel__list__item">
        <span>{{item.start_date | formatDate }} - {{item.current_position ? $t('dashboard.work_experience.ongoing') : ($options.filters.formatDate(item.end_date))}}, {{item.city}}</span>
        <h3 class="purple">{{item.function_title}}</h3>
        <h3>{{item.company_name}}</h3>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    import { GET_WORK_EXPERIENCE } from '@/store/modules/work-experience';

    @Component
    export default class WorkExperienceItem extends Vue {
        name = 'work-experience-item';

        @Prop()
        item;

    }

</script>



// WEBPACK FOOTER //
// src/components/panels/profile/WorkExperienceItem.vue